import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import LockOpenIcon from "@material-ui/icons/LockOpen";
const useStyles = makeStyles({
  root: {
    paddingTop: "15%",
  },
  divButton: {
    paddingTop: "10%",
  },
});
function LoginButton() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <hr />
      <div className={classes.divButton}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          fullWidth
          startIcon={<LockOpenIcon />}
        >
          로그인하기
        </Button>
      </div>
    </div>
  );
}
export default LoginButton;
